import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg4,
  gridSizeMdLg6,
  newCostoschema,
} from "@/shared";
import {
  useCreateCostos,
  useUpdateCostos,
} from "@/shared/actions/erp";
import {

  SingleTableBoxScene,

  SampleCheckbox,
  CustomTextField,
  CustomNumberTextField,
  CustomTextArea,
} from "@/shared/components/ui";

import {
  Grid,
} from "@mui/material";
import { useUiStore } from "@/store/ui";

import { Costos } from "@/shared/interfaces/erp/activos/costo-activo.interface";
import PlanCuentaCostoComponente from "../components/planCuentaCostos";
import { CuentasContablesKey, useCuentasContablesStore } from "@/store/erp/shared/gastos.store";
import { useGetServicioDigital, usePostServicioDigital, usePutServicioDigital } from "@/shared/actions/erp/servicio_digital.actions";
import { IServicioDigital } from "@/shared/interfaces";

const returnUrlCostos = "/inventario/costos";
export interface SaveCostosProps {
  titlePage: string;
  editCostos?: Costos;
}

type SaveFormData = {
  codigo: string;
  nombre: string;
  descripcion: string;
  costo:string;
  cif:string;
  mano_obra_directa:string;
  mano_obra_indirecta:string;
  estado: boolean;
  es_para_venta?: boolean;
  precio_1?: string;
  precio_2?: string;
  precio_3?: string;
  servicio_digital?: IServicioDigital;
};



const SaveCostos: React.FC<SaveCostosProps> = ({
  editCostos,
}) => {
  const navigate = useNavigate();
  ///* local state
  const [shrink, setShrink] = useState(false);
  // const [activoChange, setActivoChange] = useState(1);
  const selectedCuentasContables = useCuentasContablesStore(s => s.cuentasContables);
  const clearAllCuentasContables = useCuentasContablesStore(s => s.clearSelectedCuentasContables);
  const addSelectedCuentasContables = useCuentasContablesStore(s => s.setSelectedCuentasContables);


  // const handleActivoChange = useCallback((_event: any, value: any) => {
  //   setActivoChange(value);
  // }, []);


  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newCostoschema),
    defaultValues: { estado: false,es_para_venta: false },
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* mutations
  const {data: servicioDigitalData} = useGetServicioDigital(
    {
      costo_asociado: editCostos?.codigo,
    },
    !!editCostos
  );
  const createCostos = useCreateCostos({
    navigate,
    returnUrl: returnUrlCostos,
  });
  const updateCostos = useUpdateCostos({
    navigate,
    returnUrl: returnUrlCostos,
  });
  const createServicioDigital = usePostServicioDigital({
  });
  const updateServicioDigital = usePutServicioDigital({
  });
  ///* handlers

  const onSave = () => {
    if (!isValid) return;
    if (!selectedCuentasContables.length) {
      setAlert(true, "Debe seleccionar al menos una cuenta contable", "error");
      return;
    }
    try{
    if (editCostos?.id_costo) {
      return updateCostos.mutate({
        id: editCostos.id_costo,
        data: form.getValues() as any, // percent
      },
      {
        onSuccess: () => {
          if(!form.getValues().es_para_venta){
            return;
          }
          updateServicioDigital.mutate({
            id: form.getValues().servicio_digital?.id_servicio_digital!,
            data: {
              precios:[
                {
                  "estado": true,
                  "nombre": "Precio 1",
                  "precio": form.getValues().precio_1?.toString() || ""
                },
                {
                  "estado": true,
                  "nombre": "Precio 2",
                  "precio": form.getValues().precio_2?.toString() || ""
                },
                {
                  "estado": true,
                  "nombre": "Precio 3",
                  "precio": form.getValues().precio_3?.toString() || ""
                },
              ]
            },
          },
        );
        },
      }
    );
    } else {
        createCostos.mutate({...form.getValues() as any,
          cuentas_contables:JSON.stringify(selectedCuentasContables)
        },
        {
          onSuccess: (data) => {
            // console.log(data);
            if(!form.getValues().es_para_venta){
              return;
            }
            createServicioDigital.mutate({
              descripcion: data.data.nombre,
              precios: [
                {
                  "estado": true,
                  "nombre": "Precio 1",
                  "precio": form.getValues().precio_1?.toString() || ""
                },
                {
                  "estado": true,
                  "nombre": "Precio 2",
                  "precio": form.getValues().precio_2?.toString() || ""
                },
                {
                  "estado": true,
                  "nombre": "Precio 3",
                  "precio": form.getValues().precio_3?.toString() || ""
                },
              ],
              nombre: data.data.nombre,
              categoria_producto: "SERVICIO_DIGITAL",
              costo_asociado: data.data.codigo,
            })
            // data.data.codigo
            clearAllCuentasContables(CuentasContablesKey.cuentasContables);
          },
        },
      );
    }
  }
catch(error){
  console.log(error);
}
  };


  useEffect(() => {
    if(!!servicioDigitalData && servicioDigitalData?.code == 200){
      form.setValue("servicio_digital", servicioDigitalData?.data?.data?.[0]);
      form.setValue("precio_1", servicioDigitalData?.data?.data?.[0]?.precios?.[0].precio);
      form.setValue("precio_2", servicioDigitalData?.data?.data?.[0]?.precios?.[1].precio);
      form.setValue("precio_3", servicioDigitalData?.data?.data?.[0]?.precios?.[2].precio);
    }
  }, [servicioDigitalData]);

  useEffect(() => {
    if (editCostos) {
      setShrink(true);
      reset({
        ...editCostos,
      } as any);
      if(!!form.getValues().servicio_digital){
        reset({
          ...editCostos,
          servicio_digital: servicioDigitalData?.data?.data?.[0],
          precio_1: servicioDigitalData?.data?.data?.[0]?.precios?.[0].precio,
          precio_2: servicioDigitalData?.data?.data?.[0]?.precios?.[1].precio,
          precio_3: servicioDigitalData?.data?.data?.[0]?.precios?.[2].precio,
        } as any);
      }
      const cuentasContables = JSON.parse(editCostos.cuentas_contables!);
      addSelectedCuentasContables(cuentasContables, CuentasContablesKey.cuentasContables);
    }
    if (!editCostos) {
      clearAllCuentasContables(CuentasContablesKey.cuentasContables);
    }
  }, [editCostos]);
  const setAlert = useUiStore((s) => s.setAlert);




  return (
    <>
      <SingleTableBoxScene
        title="Costos"
        enableBackBtn={true}
        backPageUrl="/inventario/costos"
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, () => {
          setAlert(true, "Faltan campos por llenar", "error");
        })}
      >
        {/* <NestedTabsScene
          tabs={
            <FormTabsOnly
              onChange={handleActivoChange}
              value={activoChange}
            // justifyContent="flex-end"
            >
              <Tab label="Datos" value={1} {...a11yProps(1)} />
            </FormTabsOnly>
          }
        > */}
          <Grid container spacing={3}>
            {/* <CustomTabPanel index={activoChange} value={1}> */}
              <CustomTextField
                name="codigo"
                label="Codigo"
                control={form.control}
                defaultValue={form.getValues().codigo || ""}
                error={errors.codigo}
                helperText={errors.codigo?.message}
                shrink={shrink}
                size={gridSizeMdLg6}
              />
              <CustomTextField
                name="nombre"
                label="Nombre"
                control={form.control}
                defaultValue={form.getValues().nombre || ""}
                error={errors.nombre}
                helperText={errors.nombre?.message}
                shrink={shrink}
                size={gridSizeMdLg6}
              />
         
              <CustomNumberTextField
                label="Costos"
                error={errors.costo}
                helperText={errors.costo?.message}
                size={gridSizeMdLg3}
                control={form.control}
                name="costo"
                defaultValue={form.getValues().costo || ""}
              />
              <CustomNumberTextField
                label="Costo de Seguro y Flete (CIF)"
                name="cif"
                ///register={register("cif")}
                error={errors.cif}
                helperText={errors.cif?.message}
                shrink={shrink}
                size={gridSizeMdLg3}
                control={form.control}
                defaultValue={form.getValues().cif || ""}
              />
              <CustomNumberTextField
                label="Mano obra directa"
                name='mano_obra_directa'
                //register={register("mano_obra_directa")}
                error={errors.mano_obra_directa}
                helperText={errors.mano_obra_directa?.message}
                shrink={shrink}
                min={0}
                max={10000}
                size={gridSizeMdLg3}
                control={form.control}
                defaultValue={form.getValues().mano_obra_directa || ""}

              />
              <CustomNumberTextField
                label="Mano obra indirecta"
                name='mano_obra_indirecta'
                ///register={register("mano_obra_indirecta")}
                error={errors.mano_obra_indirecta}
                helperText={errors.mano_obra_indirecta?.message}
                shrink={shrink}
                min={0}
                max={1000}
                control={form.control}
                defaultValue={form.getValues().mano_obra_indirecta || " "}
                size={gridSizeMdLg3}
              />
               
            <Grid item {...gridSizeMdLg12}>
              <CustomTextArea
                label="Descripción"
                name="descripcion"
                control={form.control}
                error={errors.descripcion}
                helperText={errors.descripcion?.message}
                defaultValue={form.getValues().descripcion || ""}
              />
            </Grid>
            <Grid item {...gridSizeMdLg3}>
              <SampleCheckbox
                label="Estado"
                name="estado"
                sizeCheck="medium"
                control={form.control}
                defaultValue={!!form.getValues().estado|| false}
                isState
              />
            </Grid>
            <Grid item {...gridSizeMdLg3}>
              <SampleCheckbox
                label="¿Es para venta?"
                name="es_para_venta"
                control={form.control}
                sizeCheck="medium"
                defaultValue={!!form.getValues().es_para_venta|| false}
              />
            </Grid>
            <Grid item container spacing={2} {...gridSizeMdLg12}>
              {form.watch().es_para_venta?<>
                <CustomNumberTextField
                  label="Precio 1"
                  name="precio_1"
                  size={gridSizeMdLg4}
                  control={form.control}
                  error={errors.precio_1}
                  helperText={errors.precio_1?.message}
                  defaultValue={form.getValues().precio_1 || ""}
                />
                <CustomNumberTextField
                  label="Precio 2"
                  name="precio_2"
                  size={gridSizeMdLg4}
                  control={form.control}
                  error={errors.precio_2}
                  helperText={errors.precio_2?.message}
                  defaultValue={form.getValues().precio_2 || ""}
                />
                <CustomNumberTextField
                  label="Precio 3"
                  name="precio_3"
                  size={gridSizeMdLg4}
                  control={form.control}
                  error={errors.precio_3}
                  helperText={errors.precio_3?.message}
                  defaultValue={form.getValues().precio_3 || ""}
                />
              </>
              :null}
            </Grid>

            <Grid item container justifyContent="center" alignItems="center">
          {/* 
          SE QUITA FILTRO POR EMPRESA PARA DAR FUNCIONAMIENTO
           */}
          <PlanCuentaCostoComponente
            control={control}
          />
        </Grid>
            {/* </CustomTabPanel> */}
      </Grid>
        {/* </NestedTabsScene> */}

      </SingleTableBoxScene>
    </>
  );
};
export default SaveCostos;
